















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ItemTopicViewerMovie extends Vue {

  @Prop()
  readonly slide!: Json

  get src () {
    try {
      const url = new URL(this.slide.src)
      if (url.hostname.includes('youtu.be')){
        const parts = url.pathname.substr(1).split('/')
        return 'https://www.youtube.com/embed/'+parts.shift()
      } else if (url.hostname.includes('youtube')) {
        return 'https://www.youtube.com/embed/'+url.searchParams.get('v')
      } else if (url.hostname.includes('vimeo')) {
        const parts = url.pathname.substr(1).split('/')
        return 'https://player.vimeo.com/video/' + parts.shift()
      } else  {
        return this.slide.src
      }
    } catch (e) {
      return null
    }
  }
}
